import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import InputField from "../../../Components/InputField";
import { CircularProgress } from "@mui/material";
import Button from "../../../Components/Button";

const EmailAddress = () => {
  const {
    setHelperText,
    helperText,
    handleNext,
    isLoading,
    navigate,
    setEmail,
    email,
  } = useRecoveryAccountContext();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Enter your verified email address
            </div>
            <div className="text-[#60656D] mt-2 mb-2">
              You will receive an OTP via email address when you continue
            </div>
            <div className="text-[#1F2328] font-bold mt-5">Email</div>
            <div className="mt-1">
              <InputField
                id="email"
                maxLength="50"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setHelperText("");
                }}
                error={helperText !== ""}
                helperText={helperText || ""}
                //helperText={helperText ? helperText : ''} null
                onKeyUp={(e) => {
                  if (e.key === "Enter" && !isLoading) {
                    handleNext();
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            disabled={email === "" || isLoading}
            className={`w-full h-12 mt-2 ${
              email === "" || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleNext}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailAddress;
